import React from "react"

// Define props interface
interface ActionDisplayProps {
  action: string
  text: string
  color: string
  icon: React.ReactNode
}

// Action style - full-width banner with left border
export const ActionDisplay = ({
  action,
  text,
  color,
  icon,
}: ActionDisplayProps) => (
  <div
    className={`mb-3 flex w-full items-center gap-2 border-l-4 ${color.replace("border-", "border-l-")} bg-opacity-50 py-1.5 pl-3 pr-3 text-sm`}
  >
    {icon}
    <span className="font-medium">{text}</span>
  </div>
)
